import { MARKETS, DEFAULT_MARKET } from './markets.js';

/** Демо сессиясы кайсы базарда экени — браузерде сакталат */
export const MARKET_KEY = 'demo_market';

/** Белгисиз же бош код — демейки базар; ушундан башка жол жок */
export function resolveMarket(code) {
  return code && MARKETS[code] ? code : null;
}

/**
 * Учурдагы базар: адегенде шилтемедеги `?market=`, анан мурунку демо
 * сессиясы, анан демейкиси. Шилтеме күчтүү: сатуу шилтемесин баскан адам
 * мурда башка базарды ачкан болсо да, шилтемедегини көрүшү керек.
 */
export function currentMarketCode() {
  try {
    const fromUrl = resolveMarket(new URLSearchParams(window.location.search).get('market'));
    if (fromUrl) return fromUrl;
    const saved = resolveMarket(localStorage.getItem(MARKET_KEY));
    if (saved) return saved;
  } catch {
    // localStorage жабык (купуя режим) — демейкиси жетиштүү
  }
  return DEFAULT_MARKET;
}

export function getMarket(code) {
  return MARKETS[resolveMarket(code) ?? currentMarketCode()];
}

export function saveMarket(code) {
  try { localStorage.setItem(MARKET_KEY, code); } catch { /* жабык болсо — сессия ичинде гана */ }
}
